export default __webpack_public_path__ + "static/media/data_saver_green.e7eb9a7e.svg";